(function (window, angular, undefined) {
    'use strict';

    /**
     * @ngdoc overview
     * @name angulartics.adobe.analytics
     * Enables analytics support for Adobe Analytics (http://adobe.com/analytics)
     */
    angular.module('angulartics.amex.adobe.analytics', ['angulartics'])
        .config(['$analyticsProvider', function ($analyticsProvider) {

            var dtmSpecs =  require('./dtmSpecs');
            var DELIMITER = '>';
            // This will auto track based on URL changes
            $analyticsProvider.settings.pageTracking.trackRelativePath = true;

            /**
             * Track Page Views in Adobe Analytics
             * @name pageTrack
             * @param {string} path Required 'path' (string) associated with the page being viewed
             * @param {Object} additionalProperties Optional properties
             */
            $analyticsProvider.registerPageTrack(function (path, additionalProperties) {
                if (window.s && window.digitalData) {
                    var statePath =  angular.isObject(additionalProperties) && !additionalProperties['$$path'] ? additionalProperties['pageName'] : path;
                    var pageName = getPageName(statePath);
                    window.digitalData.page.pageInfo.pageName = pageName;
                    window._satellite.track('page');
                }
            });

            /**
             * Function to track an event in Adobe. This method is called by the Angulartics directive.
             * Example:
             *   <a analytics-on="click" <!-- This will be in the eventProperties when the function is called -->
             *      analytics-properties="{eventAsset: 'user-preference-anchor'}" <!-- this event asset is used when building the event -->
             *      >Click here</a>
             * @name trackEvent
             * @param {string} _ this is an implied var capturing the content of the HTML element, this is unused for this implementation
             * @param {Object} eventProperties contains the eventType (added by Angulartics) and the eventAsset (specified by dev on element)
             */
            $analyticsProvider.registerEventTrack(function (_, eventProperties) {
                // Checks to make sure both Adobe script and our digital data entities are loaded
                // Now page name is same as the route path
                if (window.s && window.digitalData) {
                    if(typeof(window.digitalData.event) != 'undefined'){window.digitalData.event.length = 0;}
                    eventProperties = getUpdatedEventAssertValue(eventProperties);
                    window.digitalData.event.push({
                        'eventInfo': {
                            'eventAction': eventProperties.eventType, // The action that was performed. Example: "click", "play", "pause" etc.
                            'eventAsset': eventProperties.eventAsset, // The asset on which the action occurred. Example : "CarousalLeftArrow", "FAQ#1" etc.
                            'eventType': 'pageInteraction'
                        }
                    });
                    window._satellite.track('event');
                }
            });

            function getUpdatedEventAssertValue(eventProperties){
                if(( typeof (eventProperties.tab) != 'undefined' ) && ( typeof(dtmSpecs.tabsNames[eventProperties.tab]) != 'undefined' )) {

                    if ((typeof (window.appVars) != 'undefined') && (typeof (window.appVars[eventProperties.tab]) != 'undefined')) {
                        var currentTab = window.appVars[eventProperties.tab];
                        var allSubTab = dtmSpecs.tabsNames[eventProperties.tab];
                        var tbname = allSubTab[currentTab].name;
                        eventProperties.eventAsset= (window.digitalData.page.pageInfo.pageName.concat(DELIMITER, tbname, DELIMITER, eventProperties.eventAsset));

                    } else
                        eventProperties.eventAsset= window.digitalData.page.pageInfo.pageName.concat(DELIMITER, eventProperties.eventAsset);
                }
                else
                    eventProperties.eventAsset= window.digitalData.page.pageInfo.pageName.concat(DELIMITER , eventProperties.eventAsset);
                return eventProperties;

            }

            function getPageName(path) {
                if(path.length === 0)
                    return path;
                var ind = path.lastIndexOf('/');
                if(ind === -1)
                    return path; // may be home need to check
                var subPath = path.substring(ind);
                // Find name of page from spec
                return dtmSpecs.pageNames[subPath] ? dtmSpecs.pageNames[subPath].pageName : path;

            }
        }]);
})(window, window.angular);



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/modules/angulartics-amex-adobe-analytics/angulartics-amex-adobe-analytics.js
// module id = 210
// module chunks = 0